export const formatValues = ({value=0}) => {
    return (Intl.NumberFormat("es-ES").format(value))
}
